import React from "react";
import "./WhatsAppCTA.css";

// Número e mensagem padrão (mesmo do footer). Troque aqui para alterar em um só lugar.
const WHATSAPP_NUMBER = "5534999203789";
const DEFAULT_MESSAGE =
  "Olá! Quero falar com um especialista em infraestrutura sobre meu projeto.";

const WhatsAppCTA = ({
  number = WHATSAPP_NUMBER,
  message = DEFAULT_MESSAGE,
  imageSrc = null,
  alt = "Fale conosco no WhatsApp",
}) => {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${number.replace(/\D/g, "")}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-cta"
      aria-label={alt}
    >
      {imageSrc ? (
        <img src={imageSrc} alt={alt} className="whatsapp-cta__img" />
      ) : (
        <span className="whatsapp-cta__icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" fill="currentColor">
            <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825.737 5.49 2.027 7.797L0 32l8.438-2.203A15.93 15.93 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333c-2.619 0-5.134-.698-7.363-2.016l-.529-.314-2.741.716.731-2.675-.431-.548a13.267 13.267 0 01-2.037-7.091C4.667 7.636 9.703 2.667 16 2.667S27.333 7.636 27.333 14c0 6.364-5.036 11.333-11.333 11.333zm6.526-8.387c-.396-.199-2.345-1.156-2.706-1.289-.361-.133-.624-.199-.887.199s-1.023 1.289-1.254 1.555c-.231.265-.462.299-.858.099-.396-.199-1.672-.617-3.188-1.963-1.177-1.048-1.971-2.345-2.201-2.74-.231-.396-.025-.61.173-.806.178-.178.396-.462.594-.693.198-.231.264-.396.396-.661.132-.265.066-.496-.033-.694s-.887-2.14-1.221-2.928c-.321-.758-.646-.654-.887-.667l-.758-.013c-.265 0-.693.099-1.056.495-.363.396-1.386 1.353-1.386 3.298s1.419 3.062 1.617 3.259c.198.198 2.794 4.246 6.771 5.94.945.403 1.687.646 2.264.826.949.297 1.813.255 2.496.154.763-.113 2.345-.958 2.674-1.884.329-.926.329-1.719.231-1.884-.099-.165-.363-.265-.759-.464z" />
          </svg>
        </span>
      )}
    </a>
  );
};

export default WhatsAppCTA;
